"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCountdownInterval = void 0;
var _react = require("react");
var _useWorkerInterval2 = require("../useWorkerInterval");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useCountdownInterval = function useCountdownInterval(_ref) {
  var start = _ref.start,
    end = _ref.end,
    _ref$initOnStart = _ref.initOnStart,
    initOnStart = _ref$initOnStart === void 0 ? false : _ref$initOnStart,
    interval = _ref.interval,
    isIncrement = _ref.isIncrement,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1000 : _ref$step,
    onEnd = _ref.onEnd;
  var _useWorkerInterval = (0, _useWorkerInterval2.useWorkerInterval)(interval !== null && interval !== void 0 ? interval : 1000),
    worker = _useWorkerInterval.worker,
    startWorker = _useWorkerInterval.startWorker,
    stopTimer = _useWorkerInterval.stopTimer;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRunning = _useState2[0],
    setIsRunning = _useState2[1];
  var _useState3 = (0, _react.useState)(start),
    _useState4 = _slicedToArray(_useState3, 2),
    initStart = _useState4[0],
    setInitStart = _useState4[1];
  (0, _react.useEffect)(function () {
    if (worker) {
      worker.onmessage = function (e) {
        if (isIncrement) {
          setInitStart(function (prev) {
            return prev + step;
          });
        } else {
          setInitStart(function (prev) {
            return prev - step;
          });
        }
      };
    }
    if (initOnStart && worker) {
      startWorker();
    }
    return function () {
      worker === null || worker === void 0 ? void 0 : worker.terminate();
    };
  }, [worker]);
  var outputNumber = (0, _react.useMemo)(function () {
    var seconds = Math.floor(initStart / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;
    return {
      seconds: seconds,
      minutes: minutes,
      hours: hours
    };
  }, [initStart]);
  var outputString = (0, _react.useMemo)(function () {
    return {
      minutes: ('0' + outputNumber.minutes).slice(-2),
      seconds: ('0' + outputNumber.seconds).slice(-2),
      hours: ('0' + outputNumber.hours).slice(-2)
    };
  }, [outputNumber]);
  var startCounter = function startCounter() {
    setIsRunning(true);
    startWorker();
  };
  var stopCounter = function stopCounter() {
    setIsRunning(false);
    stopTimer();
  };
  var resetCounter = function resetCounter() {
    var autoStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setInitStart(start);
    if (autoStart) {
      startCounter();
    } else {
      stopCounter();
    }
  };
  (0, _react.useEffect)(function () {
    if (end && end <= initStart) {
      stopCounter();
      onEnd === null || onEnd === void 0 ? void 0 : onEnd();
    }
  }, [end, initStart]);
  return {
    counterNumber: outputNumber,
    counterString: outputString,
    counter: initStart,
    startCounter: startCounter,
    isRunning: isRunning,
    stopCounter: stopCounter,
    resetCounter: resetCounter
  };
};
exports.useCountdownInterval = useCountdownInterval;